import { render } from "./chineseDrink.vue?vue&type=template&id=5886a406&scoped=true"
import script from "./chineseDrink.vue?vue&type=script&lang=js"
export * from "./chineseDrink.vue?vue&type=script&lang=js"

import "./chineseDrink.vue?vue&type=style&index=0&id=5886a406&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5886a406"

export default script